import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20sports%20action%20collage%20with%20football%20basketball%20tennis%20and%20esports%20dynamic%20motion%20atmosphere%20warm%20golden%20and%20red%20tones%20energy%20and%20excitement%20artistic%20composition&width=1920&height=800&seq=cta-sports-action&orientation=landscape"
          alt="加入开云爱体育"
          title="开云爱体育注册"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/30"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
          准备好开启精彩体育之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-10 max-w-lg mx-auto leading-relaxed">
          立即加入开云爱体育，享受全球顶级赛事资讯、专业分析和安全便捷的体育娱乐服务。百万用户的选择，值得信赖。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-10 py-4 bg-accent-500 text-foreground-950 font-bold text-sm rounded-full hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
          >
            立即注册
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-10 py-4 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-medium text-sm rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}